export default __webpack_public_path__ + "static/wojciechl-b2cef4d6918ade26aa028d99e39e7a68.jpg";